<template>
    <div>
        <board-filter data-aos="fade-up" class="mb-40px mb-md-80px" />

        <v-row data-aos="fade-up" data-aos-delay="200">
            <!-- S: story -->
            <v-col v-for="(success, index) in successes" :key="index" cols="6" md="4">
                <story-item :to="`/story/${success._id}`" :thumb="success.thumb">
                    {{ success.subject }}
                    <template #date>{{ $dayjs(success.createdAt).format("YYYY-MM-DD") }}</template>
                </story-item>
            </v-col>
            <!-- E: story -->

            <v-col cols="12" v-if="showsMore">
                <v-layout justify-center>
                    <v-progress-circular indeterminate size="100" width="5" v-intersect="onIntersectMore" />
                </v-layout>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import api from "@/api";
import { PANSIM_TYPES } from "@/assets/variables";
import BoardFilter from "@/components/client/board/board-filter.vue";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";
import UTxtDefault from "@/components/publish/styles/typography/u-txt-default.vue";
import UTxtMedium from "@/components/publish/styles/typography/u-txt-medium.vue";

import StoryItem from "@/components/client/board/skin/story/item.vue";

let site_default = PANSIM_TYPES.SEX_OFFENCE.value;

export default {
    props: {
        category: { type: String, default: "" },
    },
    components: {
        BoardFilter,
        UTitDefault,
        UTxtDefault,
        UTxtMedium,

        StoryItem,
    },
    data: () => ({
        successes: [],
        summary: { totalCount: 0 },

        page: 1,
        limit: 30,

        loading: false,
    }),
    computed: {
        code() {
            return this.category || this.$route.query.code || null;
        },
        showsMore() {
            return 0 < this.summary.totalCount && this.page * this.limit < this.summary.totalCount;
        },
        headers() {
            return {
                skip: (this.page - 1) * this.limit,
                limit: this.limit,
            };
        },
        params() {
            let { ...params } = this.$route.query;

            delete params["page"];

            params["code"] = this.code;
            params["site"] = site_default;

            params["searchKey"] = params["searchKey"] || "subject";
            params["searchValue"] = params["searchValue"] || null;

            if (!params["searchValue"]) delete params["searchValue"];

            return params;
        },
    },
    methods: {
        async init() {
            this.successes = [];
            this.summary = { totalCount: 0 };
            this.page = 1;
            await this.search();
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { headers, params } = this;
                let { summary, successes } = await api.v1.success.gets({
                    headers,
                    params,
                });

                this.successes = this.successes.concat(...successes);
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
        onIntersectMore(entries, observer, isIntersecting) {
            if (!isIntersecting) return;
            if (this.loading) return;
            this.page += 1;
            this.search();
        },
    },
    watch: {
        params() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>
